// removed by extract-text-webpack-plugin
module.exports = {"page":"style__page___1iSSk","wrapper":"style__wrapper___1lFKI","footer-push":"style__footer-push___uL6vl","content":"style__content___3g-z7","booking-content":"style__booking-content___39ekb"};


//////////////////
// WEBPACK FOOTER
// ./components/Page/style.scss
// module id = 1138
// module chunks = 0